const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
const isTablet = !isDesktop && window.matchMedia('(min-width: 768px)').matches;
const isMobile = !isDesktop && !isTablet;

let hasChangedState = false;

export let _state = {
    scrollDirection: 0,
    isUserActive: false,
    lenisInit: null,
    isScrollingToAnchor: false,

    isDesktop: isDesktop,
    isTablet: isTablet,
    isMobile: isMobile,
    prevDesktop: isDesktop,
    prevTablet: isTablet,
    prevMobile: isMobile,

    vh: window.innerHeight * 0.01,
    svh: document.documentElement.clientHeight * 0.01,

    windowResizeEvents: ['resize', 'resizePage', 'orientationchange'],
    interactionEvents: ['mousemove', 'mousewheel', 'touchmove', 'keydown', 'mousedown', 'focus', 'orientationchange', 'wheel'],

    updateState(newState){
        for (const key in newState) {
            if (_state[key] !== newState[key]) {
                hasChangedState = true;
                break;
            }
        }
        if (hasChangedState) {
            _state = { ..._state, ...newState };
            if (newState.hasOwnProperty('scrollDirection')){
                window.dispatchEvent(new Event('scrollDirectionChanged'));
            }
            hasChangedState = false;
        }
    },
}

export const getLocalState = () => {
    const scriptDataLocal = typeof scriptData !== 'undefined' ? scriptData : null;
    return new Promise((resolve, reject) => {
        _state.updateState({scriptData: scriptDataLocal});
        document.querySelector('#your-wp_localize_script-id')?.remove();
        resolve();
    });
}